// API
//export const URL_API = 'http://localhost:54847/api';
//export const URL_PORTAL = 'https://localhost:54847';

// TEST
//export const URL_API = 'https://mas-bienestar-staging-uat-test-api.azurewebsites.net/api';
//export const URL_PORTAL = 'https://eap-bienestar-public.azurewebsites.net';

// PRE PROD
//export const URL_API = 'https://mas-bienestar-api-desa.azurewebsites.net/api';
//export const URL_PORTAL = 'https://mas-bienestar-intranet-desa.azurewebsites.net/';

// PROD
export const URL_API = 'https://api.portalmasbienestar.com/api';
export const URL_PORTAL = 'https://portaldebienestar.com/';

// CONFIG
export const APP_CONFIG = 'APP_CONFIG';
export const AUTH_USER_CODE = 'AUTH_USER_CODE';
export const COUNTRY_GATEWAY_PAGE_CODE = 'COUNTRY_GATEWAY_PAGE_CODE';
export const CONVERSATION_CODE = 'CONVERSATION_CODE';
export const DEVICE_INFO = 'DEVICE_INFO';
export const LOGIN_FROM_INSIDE = 'LOGIN_FROM_INSIDE';

// PAGE VIEW MODELS
export const HOME_PAGE_VIEW_MODEL = 'HOME_PAGE_VIEW_MODEL';
export const ARTICLES_PAGE_VIEW_MODEL = 'ARTICLES_PAGE_VIEW_MODEL';
export const TESTS_PAGE_VIEW_MODEL = 'TESTS_PAGE_VIEW_MODEL';
export const CHAT_PAGE = 'CHAT_PAGE';
export const COMPANY_COUNTRIES = 'COMPANY_COUNTRIES';

// URLs
export const URL_LOGIN = `${URL_API}/login`;
export const URL_LOGOUT = `${URL_API}/logout`;
export const URL_LOG_ENTER = `${URL_API}/login/LogEnter`;
export const URL_PROFILE = `${URL_API}/profile`;
export const URL_REGISTER = `${URL_API}/register`;
export const URL_COUNTRIES = `${URL_API}/countries`;
export const URL_CONFIG = `${URL_API}/config`;
export const URL_ARTICLES = `${URL_API}/articles`;
export const URL_ANALYTIC = `${URL_API}/analytic`;
export const URL_SEARCH = `${URL_API}/search`;
export const URL_CATEGORIES = `${URL_API}/categories`;
export const URL_TESTS = `${URL_API}/tests`;
export const URL_APP_USER_TESTS = `${URL_API}/app-user-tests`;
export const URL_CONVERSATION = `${URL_API}/conversations`;
export const URL_CONTACT = `${URL_API}/contact`;
export const URL_CONTACT_FROM = `${URL_API}/contact/contactFrom`;
export const URL_RECOMMEND_PORTAL = `${URL_API}/contact/recommend`;
export const URL_APP_USER_CONTACTS = `${URL_API}/app-user-contacts`;
export const URL_COMPANY_SERVICES = `${URL_API}/company-services`;
export const URL_NOTIFICATIONS = `${URL_API}/notifications`;
export const URL_RECOVER_PASSWORD = `${URL_API}/recover-password`;
export const URL_NOTE = `${URL_API}/mostReadNotes`;
export const URL_HOME = `${URL_API}/home`;
export const URL_ISLOGGED = `${URL_API}/islogged`;

export const URL_FILE = `${URL_API}/file`;

// Const
export const CHAT_MESSAGE = 'CHAT_MESSAGE';
export const APP_NOTIFICATION = 'APP_NOTIFICATION';
export const COUNTRYGATEWAY_MAINMESSAGE = 'COUNTRYGATEWAY_MAINMESSAGE';
export const COUNTRYGATEWAY_WARNINGMESSAGE = 'COUNTRYGATEWAY_WARNINGMESSAGE';
export const MENU_MAIN_MESSAGE = 'MENU_MAIN_MESSAGE';

// Rule Codes
export const LESSTHAN = 'LESSTHAN';
export const LESSEQUAL = 'LESSEQUAL';
export const EQUAL = 'EQUAL';
export const GREATEREQUAL = 'GREATEREQUAL';
export const GREATERTHAN = 'GREATERTHAN';
export const POSITIVE = 'POSITIVE';
export const NEGATIVE = 'NEGATIVE';

// Action Types
export const OPEN_PAGE = 'OPEN_PAGE';

// Pages from
export const CONTACT_GATEWAY = 'CONTACT_GATEWAY';
export const CHAT = 'CHAT';
export const CONTACT = 'CONTACT';
export const ARTICLES = 'ARTICLES';
export const TESTS = 'TESTS';
export const REGISTER = 'REGISTER';
export const MY_SERVICES = 'MY_SERVICES';
export const HISTORY_GATEWAY = 'HISTORY_GATEWAY';
export const FAVORITES = 'FAVORITES';
export const TEST_HISTORY = 'TEST_HISTORY';

//WPP link
export const WPP_LINK = 'https://walink.co/835cea';

//Captcha key
export const SITE_KEY = '6LdjPsQZAAAAADwMtKjgQKSi477-SfxCbJXCumFB';

//Vimeo
export const CLIENT_ID = '464b3e0abbf935eb77fc204995911f7d6848309a';
export const CLIENT_SECRET =
  'ehx7/0TSH6zSpqMyvZCY2WOHl8vkLrzD5rBzN6PPlPme4MQ0ksJAa7WXqUTKR1IU0dhgYcUjR/HjSO0PEZvsGCvQH6H1OehIP99cmbrcsiy2ywlrfmRIWyzXqoZXKr91';
export const PROJECT_ID = '15314402';
export const USER_ID = '123835138';
export const ACCESS_TOKEN = '45bac21fd7e6b49eaa8e78552d912ba5';
export const VIMEO_URL =
  'https://api.vimeo.com/users/' +
  USER_ID +
  '/projects/' +
  PROJECT_ID +
  '/videos';

export const UserTypeCode = {
  EMPLOYEE: 'EMPLOYEE',
  FAMILIAR: 'FAMILIAR',
};

export const Translation = {
  LOADING: 'Cargando...',
  NO_INTERNET: 'Ups, al parecer no hay internet',
  NO_INTERNET_CHECK: 'Chequea tu conexi�n a Internet e intenta nuevamente',
};

export const RegEx = {
  email:
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  youtubeId:
    /(?:https?:\/\/(?:[a-z]+.)?)(?:youtu\.?be(?:\.com)?\/)(?:embed\/)?(?:(?:(?:(?:watch\?)?(?:time_continue=(?:[0-9]+))?.+v=)?([a-zA-Z0-9_-]+))(?:\?t\=(?:[0-9a-zA-Z]+))?)/,
  vimeo:
    /(http|https)?:\/\/(www\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/([^\/]*)\/videos\/|)(\d+)(?:|\/\?)/,
};

export const AnalyticCode = {
  TESTVIEW: 'TESTVIEW',
  CONTENTVIEW: 'CONTENTVIEW',
  INFORMATIVE_SERVICE_VIEW: 'INFORMATIVE_SERVICE_VIEW',
};
